// extracted by mini-css-extract-plugin
module.exports = {"container":"modalInnerBody_container__2bsvc","wrapper":"modalInnerBody_wrapper__zFg4L","bodyContainer":"modalInnerBody_bodyContainer__1foUi"};